const searchKey = {
  state: {
    searchKey: ''
  },
  mutations: {
    SET_SEAECH_KEY(state, key) {
      state.searchKey = key
    }
  },
  actions: {
    searchKey({ commit }, key) {
      return new Promise(resolve => {
        commit('SET_SEAECH_KEY', key)
        resolve()
      })
    }
  }
}

export default searchKey
